import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$video = this.$('video')[0]

        this.initializeEvents()
    }

    initializeEvents() {
        this.canPlayBind = this.onCanPlay.bind(this)

        this.$video.addEventListener('canplay', this.canPlayBind);
    }

    // Callabcks

    onCanPlay() {
        this.$video.classList.add('is-canplay')
    }

    // Methods

    toggle(e) {
        const {target, way} = e
        const $video = target.querySelector('video')

        if(way === "enter") {
            if($video.paused) {
                $video.play()
            }
        } else {
            if(!$video.paused) {
                $video.pause()
            }
        }
    }

    destroy() {
        super.destroy()

        this.$video.removeEventListener('canplay', this.canPlayBind);
    }
}
